import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// third-party module imports
import { NgxWebstorageModule } from 'ngx-webstorage';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { TextMaskModule } from 'angular2-text-mask';

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

// custom module imports
import {
  SpinnerModule,
  TableModule,
  AutocompleteModule,
} from './modules';

// custom component imports
import {
  ModalPopupComponent,
  IconComponent,
  LoaderComponent,
  SpinnerComponent,
  ConfirmationDialogComponent,
  ValidationErrorsComponent,
  AccordionComponent,
  ServerValidationErrorComponent,
  StatusLabelComponent
} from './components';

// custom service imports
import {
  ToasterService,
  ConfirmationDialogService,
  StorageService,
  SharedService,
} from './services';

// custom pipe imports
import {
  CurrencyFormat,
  UnitFormat
} from './pipes';

// custom directive imports
import {
  IsValidNumberDirective,
  TrimWhitespaceDirective,
  TrimSpecialChar
} from './directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // third-party modules
    NgxWebstorageModule.forRoot({ prefix: 'sif', separator: '|'}),
    NgbModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    // custom modules
    SpinnerModule,
    TableModule,
    AutocompleteModule,
  ],
  declarations: [
    SpinnerComponent,
    LoaderComponent,
    IconComponent,
    ModalPopupComponent,
    ConfirmationDialogComponent,
    ValidationErrorsComponent,
    ServerValidationErrorComponent,
    AccordionComponent,
    CurrencyFormat,
    UnitFormat,
    IsValidNumberDirective,
    TrimWhitespaceDirective,
    TrimSpecialChar,
    StatusLabelComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // third-party modules
    NgbModule,
    OwlDateTimeModule,
    TextMaskModule,

    // custom modules
    SpinnerModule,
    TableModule,
    AutocompleteModule,

    // custom components
    SpinnerComponent,
    LoaderComponent,
    IconComponent,
    ModalPopupComponent,
    ConfirmationDialogComponent,
    ValidationErrorsComponent,
    ServerValidationErrorComponent,
    AccordionComponent,
    StatusLabelComponent,

    // custom pipes
    CurrencyFormat,
    UnitFormat,

    // custom directives
    IsValidNumberDirective,
    TrimWhitespaceDirective,
    TrimSpecialChar
  ],
  providers: [
    ToasterService,
    ConfirmationDialogService,
    StorageService,
    SharedService,
    {
      provide: OWL_DATE_TIME_FORMATS,
      useValue: MY_NATIVE_FORMATS
    }
  ],
  entryComponents: [ ConfirmationDialogComponent ]
})
export class SharedModule { }
